import { IObjectControllableFeature } from "../../../../../../../documaker/domain/format/objects";
import { IXElementContentsObjectBean, IXElementContentsObjectRelationalBean } from "../../../beans";
import { RelationTranslator } from "./RelationTranslator";
import { ILinkedObjectTranslatable } from "./ILinkedObjectTranslatable";

export class ObjectControllableFeatureTranslator<T> {
  constructor(action: string, private readonly reference: ILinkedObjectTranslatable<T>) {
    this.relationalItems = new RelationTranslator(action);
  }

  from(bean: IXElementContentsObjectBean): IObjectControllableFeature<T> {
    return this.relationalItems.from(
      bean,
      is => ({
        isEnable: (0 < is.length),
        target: this.reference.from(is[0]),
      }),
      {
        isEnable: false,
        target: null,
      });
  }

  to(object: IObjectControllableFeature<T>): IXElementContentsObjectRelationalBean {
    return object.isEnable
      ? this.relationalItems.to([
        this.reference.to(object.target),
      ])
      : undefined;
  }

  private readonly relationalItems: RelationTranslator;
}
